// ============================================================================
// Blog post list — category filter + load more
// ----------------------------------------------------------------------------
// Replaces the inline List.js setup. Each card is server-rendered with a
// `data-category-slugs` attribute (e.g. "design,interior"). We toggle a
// `.is-hidden` class to show/hide cards client-side, no AJAX, no re-render.
// ============================================================================

const PAGE_SIZE = 2; // how many cards reveal per "load more" click

document.addEventListener("DOMContentLoaded", function () {
  const categoryItems = document.querySelectorAll(
    ".blog-post__categories-item",
  );
  const cards = Array.from(document.querySelectorAll(".blog-post__card-item"));
  const loadMoreButton = document.querySelector(".blog-post__load-more");

  if (!categoryItems.length || !cards.length) return;

  // State: which category is active, and how many matching cards are visible.
  let activeSlug = "all-articles";
  let visibleCount = PAGE_SIZE;

  // Pre-parse category slugs into arrays per card so we don't split on every
  // filter pass.
  cards.forEach(function (card) {
    const raw = card.getAttribute("data-category-slugs") || "";
    card._catSlugs = raw.split(",").map(function (s) {
      return s.trim();
    });
  });

  function cardMatches(card, slug) {
    if (slug === "all-articles") return true;
    return card._catSlugs.indexOf(slug) !== -1;
  }

  function render() {
    // Filter first: figure out which cards belong to the active category.
    const matching = cards.filter(function (card) {
      return cardMatches(card, activeSlug);
    });

    // Show the first `visibleCount` of those, hide the rest.
    matching.forEach(function (card, i) {
      if (i < visibleCount) {
        card.classList.remove("is-hidden");
        card.style.display = "";
      } else {
        card.classList.add("is-hidden");
        card.style.display = "none";
      }
    });

    // Cards that don't match the active category get hidden regardless.
    cards.forEach(function (card) {
      if (!cardMatches(card, activeSlug)) {
        card.classList.add("is-hidden");
        card.style.display = "none";
      }
    });

    // Show or hide the load-more button based on whether more matches exist.
    if (loadMoreButton) {
      if (matching.length > visibleCount) {
        loadMoreButton.style.display = "";
      } else {
        loadMoreButton.style.display = "none";
      }
    }
  }

  // --- Category click ------------------------------------------------------
  categoryItems.forEach(function (item) {
    item.addEventListener("click", function (e) {
      categoryItems.forEach(function (other) {
        other.classList.remove("active");
      });
      e.currentTarget.classList.add("active");

      activeSlug =
        e.currentTarget.getAttribute("category-slug") || "all-articles";
      visibleCount = PAGE_SIZE; // reset paging when category changes
      render();
    });
  });

  // --- Load more click -----------------------------------------------------
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", function () {
      visibleCount += PAGE_SIZE;
      render();
    });
  }

  // --- Initial state -------------------------------------------------------
  // Mirror the original behaviour: the first category item is the "All
  // Articles" pill, and is active by default.
  categoryItems[0].classList.add("active");
  activeSlug = categoryItems[0].getAttribute("category-slug") || "all-articles";
  render();
});
